import { camelToKebab } from '../../../utils/tailwindcss';

export const DISPLAY = 'display';
export const POSITION = 'position';
export const TOP = 'top';
export const RIGHT = 'right';
export const BOTTOM = 'bottom';
export const LEFT = 'left';
export const TRANSFORM = 'transform';
export const ROTATE = 'rotate';
export const Z_INDEX = 'zIndex';
export const BOX_SIZING = 'boxSizing';
export const WIDTH = 'width';
export const HEIGHT = 'height';
export const MIN_WIDTH = 'minWidth';
export const MIN_HEIGHT = 'minHeight';
export const MAX_WIDTH = 'maxWidth';
export const MAX_HEIGHT = 'maxHeight';
export const PADDING = 'padding';
export const PADDING_TOP = 'paddingTop';
export const PADDING_RIGHT = 'paddingRight';
export const PADDING_BOTTOM = 'paddingBottom';
export const PADDING_LEFT = 'paddingLeft';
export const MARGIN = 'margin';
export const MARGIN_TOP = 'marginTop';
export const MARGIN_RIGHT = 'marginRight';
export const MARGIN_BOTTOM = 'marginBottom';
export const MARGIN_LEFT = 'marginLeft';
export const BG = 'background';
export const BG_COLOR = `${BG}Color`;
export const BG_IMAGE = `${BG}Image`;
export const BG_SIZE = `${BG}Size`;
export const BG_POSITION = `${BG}Position`;
export const BG_REPEAT = `${BG}Repeat`;
export const FONT_SIZE = 'fontSize';
export const FONT_WEIGHT = 'fontWeight';
export const FONT_STYLE = 'fontStyle';
export const LINE_HEIGHT = 'lineHeight';
export const TEXT_WRAP = 'textWrap';
export const FONT_FAMILY = 'fontFamily';
export const LETTER_SPACING = 'letterSpacing';
export const TEXT_ALIGN = 'textAlign';
export const VERTICAL_ALIGN = 'verticalAlign';
export const COLOR = 'color';
export const OPACITY = 'opacity';
export const BORDER = 'border';
export const BD_TOP = `${BORDER}Top`;
export const BD_TOP_WIDTH = `${BD_TOP}Width`;
export const BD_TOP_STYLE = `${BD_TOP}Style`;
export const BD_TOP_COLOR = `${BD_TOP}Color`;
export const BD_RIGHT = `${BORDER}Right`;
export const BD_RIGHT_WIDTH = `${BD_RIGHT}Width`;
export const BD_RIGHT_STYLE = `${BD_RIGHT}Style`;
export const BD_RIGHT_COLOR = `${BD_RIGHT}Color`;
export const BD_BOTTOM = `${BORDER}Bottom`;
export const BD_BOTTOM_WIDTH = `${BD_BOTTOM}Width`;
export const BD_BOTTOM_STYLE = `${BD_BOTTOM}Style`;
export const BD_BOTTOM_COLOR = `${BD_BOTTOM}Color`;
export const BD_LEFT = `${BORDER}Left`;
export const BD_LEFT_WIDTH = `${BD_LEFT}Width`;
export const BD_LEFT_STYLE = `${BD_LEFT}Style`;
export const BD_LEFT_COLOR = `${BD_LEFT}Color`;
export const BD_RADIUS = 'borderRadius';
export const BD_TL_RADIUS = 'borderTopLeftRadius';
export const BD_TR_RADIUS = 'borderTopRightRadius';
export const BD_BR_RADIUS = 'borderBottomRightRadius';
export const BD_BL_RADIUS = 'borderBottomLeftRadius';
export const BD_WIDTH = 'borderWidth';
export const BD_STYLE = 'borderStyle';
export const BD_COLOR = 'borderColor';
export const OUTLINE = 'outline';
export const OL_WIDTH = `${OUTLINE}Width`;
export const OL_STYLE = `${OUTLINE}Style`;
export const OL_COLOR = `${OUTLINE}Color`;
export const OL_OFFSET = `${OUTLINE}Offset`;
export const BOX_SHADOW = 'boxShadow';
export const GRID_TEMPLATE_COLUMNS = 'gridTemplateColumns';
export const GRID_TEMPLATE_ROWS = 'gridTemplateRows';
export const COLUMN_GAP = 'columnGap';
export const ROW_GAP = 'rowGap';
export const GRID_COLUMN = 'gridColumn';
export const GRID_COLUMN_START = 'gridColumnStart';
export const GRID_COLUMN_END = 'gridColumnEnd';
export const GRID_ROW = 'gridRow';
export const GRID_ROW_START = 'gridRowStart';
export const GRID_ROW_END = 'gridRowEnd';
export const GRID_JUSTIFY_ITEMS = 'justifyItems';
export const GRID_JUSTIFY_SELF = 'justifySelf';
export const FLEX_DIRECTION = 'flexDirection';
export const FLEX_WRAP = 'flexWrap';
export const FLEX_FLOW = 'flexFlow';
export const JUSTIFY_CONTENT = 'justifyContent';
export const ALIGN_ITEMS = 'alignItems';
export const ALIGN_CONTENT = 'alignContent';
export const ORDER = 'order';
export const FLEX_GROW = 'flexGrow';
export const FLEX_SHRINK = 'flexShrink';
export const FLEX_BASIS = 'flexBasis';
export const FLEX = 'flex';
export const ALIGN_SELF = 'alignSelf';
export const TRANSITION_PROPERTY = 'transitionProperty';
export const TRANSITION_BEHAVIOR = 'transitionBehavior';
export const TRANSITION_DURATION = 'transitionDuration';
export const TRANSITION_TIMING_FUNCTION = 'transitionTimingFunction';
export const TRANSITION_DELAY = 'transitionDelay';
export const ANIMATION = 'animation';
export const CURSOR = 'cursor';

export const OVERFLOW = 'overflow';
export const OVERFLOW_X = `${OVERFLOW}X`;
export const OVERFLOW_Y = `${OVERFLOW}Y`;

export const SCROLLBAR = 'scrollbar';
export const SCROLLBAR_WIDTH = `${SCROLLBAR}Width`;
export const SCROLLBAR_THUMB = `${SCROLLBAR}Thumb`;
export const SCROLL = 'scroll';
export const SCROLL_BEHAVIOR = `${SCROLL}Behavior`;
export const SNAP = `snap`;
export const SCROLL_SNAP_ALIGN = `${SCROLL}SnapAlen`;
export const SCROLL_SNAP_STOP = `${SCROLL}SnapStop`;

export const MASK_COMPOSITE = "maskComposite";
export const MASK_CLIP = "maskClip";
export const MASK_MODE = "maskMode";
export const MASK_ORIGIN = "maskOrigin";
export const MASK_POSITION = "maskPosition";
export const MASK_REPEAT = "maskRepeat";
export const MASK_SIZE = "maskSize";
export const MASK_TYPE = "maskType";
export const MASK_IMAGE = "maskImage";
export const BACKGROUND = "background";
export const BACKGROUND_IMAGE = "backgroundImage";
export const BACKGROUND_REPEAT = "backgroundRepeat";
export const BACKGROUND_SIZE = "backgroundSize";


// UI配置面板标识前缀.
export const PREFIX = 'style-design-board';


export const DISPLAY_RADIO_GROUP_ID = `${PREFIX}-${DISPLAY}-radio-group`;
export const POSITION_RADIO_GROUP_ID = `${PREFIX}-position-radio-group`;
export const TOP_INPUT_ID = 'style-design-board-top-input';
export const RIGHT_INPUT_ID = 'style-design-board-right-input';
export const BOTTOM_INPUT_ID = 'style-design-board-bottom-input';
export const LEFT_INPUT_ID = 'style-design-board-left-input';
export const ROTATE_INPUT_ID = `${PREFIX}-${ROTATE}-input`;
export const Z_INDEX_INPUT_ID = `${PREFIX}-${camelToKebab(Z_INDEX)}-input`;

export const TOP_DISPLAY_ICON_ID = `${PREFIX}-${TOP}-display-icon`;
export const RIGHT_DISPLAY_ICON_ID = `${PREFIX}-${RIGHT}-display-icon`;
export const BOTTOM_DISPLAY_ICON_ID = `${PREFIX}-${BOTTOM}-display-icon`;
export const LEFT_DISPLAY_ICON_ID = `${PREFIX}-${LEFT}-display-icon`;

export const BOX_SIZING_RADIO_GROUP_ID = `${PREFIX}-${camelToKebab(BOX_SIZING)}-radio-group`;
export const WIDTH_INPUT_ID = 'style-design-board-width-input';
export const HEIGHT_INPUT_ID = 'style-design-board-height-input';
export const MIN_WIDTH_INPUT_ID = 'style-design-board-min-width-input';
export const MAX_WIDTH_INPUT_ID = 'style-design-board-max-width-input';
export const MIN_HEIGHT_INPUT_ID = 'style-design-board-min-height-input';
export const MAX_HEIGHT_INPUT_ID = 'style-design-board-max-height-input';
export const PADDING_TOP_INPUT_ID = 'style-design-board-padding-top-input';
export const PADDING_RIGHT_INPUT_ID = 'style-design-board-padding-right-input';
export const PADDING_BOTTOM_INPUT_ID = 'style-design-board-padding-bottom-input';
export const PADDING_LEFT_INPUT_ID = 'style-design-board-padding-left-input';
export const MARGIN_TOP_INPUT_ID = 'style-design-board-margin-top-input';
export const MARGIN_RIGHT_INPUT_ID = 'style-design-board-margin-right-input';
export const MARGIN_BOTTOM_INPUT_ID = 'style-design-board-margin-bottom-input';
export const MARGIN_LEFT_INPUT_ID = 'style-design-board-margin-left-input';

export const MIN_WIDTH_DISPLAY_ICON_ID = `${PREFIX}-${camelToKebab(MIN_WIDTH)}-display-icon`;
export const MAX_WIDTH_DISPLAY_ICON_ID = `${PREFIX}-${camelToKebab(MAX_WIDTH)}-display-icon`;
export const MIN_HEIGHT_DISPLAY_ICON_ID = `${PREFIX}-${camelToKebab(MIN_HEIGHT)}-display-icon`;
export const MAX_HEIGHT_DISPLAY_ICON_ID = `${PREFIX}-${camelToKebab(MAX_HEIGHT)}-display-icon`;

export const FONT_SIZE_INPUT_ID = `${PREFIX}-${camelToKebab(FONT_SIZE)}-input`;
export const FONT_WEIGHT_INPUT_ID = `${PREFIX}-${camelToKebab(FONT_WEIGHT)}-input`;
export const LINE_HEIGHT_INPUT_ID = `${PREFIX}-${camelToKebab(LINE_HEIGHT)}-input`;
export const LETTER_SPACING_INPUT_ID = `${PREFIX}-${camelToKebab(LETTER_SPACING)}-input`;
export const TEXT_ALIGN_RADIO_GROUP_ID = `${PREFIX}-${camelToKebab(TEXT_ALIGN)}-radio-group`;
export const VERTICAL_ALIGN_RADIO_GROUP_ID = `${PREFIX}-${camelToKebab(VERTICAL_ALIGN)}-radio-group`;

export const FONT_SIZE_DISPLAY_ICON_ID = `${PREFIX}-${camelToKebab(FONT_SIZE)}-display-icon`;
export const FONT_WEIGHT_DISPLAY_ICON_ID = `${PREFIX}-${camelToKebab(FONT_WEIGHT)}-display-icon`;
export const LINE_HEIGHT_DISPLAY_ICON_ID = `${PREFIX}-${camelToKebab(LINE_HEIGHT)}-display-icon`;
export const LETTER_SPACING_DISPLAY_ICON_ID = `${PREFIX}-${camelToKebab(LETTER_SPACING)}-display-icon`;
export const FONT_WRAP_MENU_ICON_ID = `${PREFIX}-${camelToKebab(TEXT_WRAP)}-text-wrap`;
export const FONT_FAMILY_MENU_ICON_ID = `${PREFIX}-${camelToKebab(FONT_FAMILY)}-font-family`;
export const FONT_SIZE_MENU_ICON_ID = `${PREFIX}-${camelToKebab(FONT_SIZE)}-menu-icon`;
export const FONT_WEIGHT_MENU_ICON_ID = `${PREFIX}-${camelToKebab(FONT_WEIGHT)}-menu-icon`;
export const LINE_HEIGHT_MENU_ICON_ID = `${PREFIX}-${camelToKebab(LINE_HEIGHT)}-menu-icon`;
export const LETTER_SPACING_MENU_ICON_ID = `${PREFIX}-${camelToKebab(LETTER_SPACING)}-menu-icon`;
export const FONT_SIZE_MENU_ID = `${PREFIX}-${camelToKebab(FONT_SIZE)}-menu`;
export const FONT_WEIGHT_MENU_ID = `${PREFIX}-${camelToKebab(FONT_WEIGHT)}-menu`;
export const LINE_HEIGHT_MENU_ID = `${PREFIX}-${camelToKebab(LINE_HEIGHT)}-menu`;
export const LETTER_SPACING_MENU_ID = `${PREFIX}-${camelToKebab(LETTER_SPACING)}-menu`;
export const COLOR_PICKER_ID = `${PREFIX}-${COLOR}-color-picker`;
export const COLOR_HEX_INPUT_ID = `${PREFIX}-${COLOR}-hex-input`;
export const COLOR_OPACITY_INPUT_ID = `${PREFIX}-${COLOR}-opacity-input`;

export const BACKGROUND_DISPLAY_ICON_ID = 'style-design-board-background-display-icon';
export const BG_COLOR_PICKER_ID = `${PREFIX}-${camelToKebab(BG_COLOR)}-color-picker`;
export const BG_COLOR_HEX_INPUT_ID = `${PREFIX}-${camelToKebab(BG_COLOR)}-hex-input`;
export const BG_COLOR_OPACITY_INPUT_ID = `${PREFIX}-${camelToKebab(BG_COLOR)}-opacity-input`;

export const OPACITY_INPUT_ID = `${PREFIX}-${OPACITY}-input`;
export const BD_RADIUS_INPUT_ID = `${PREFIX}-${camelToKebab(BD_RADIUS)}-input`;
export const BD_TL_RADIUS_INPUT_ID = `${PREFIX}-${camelToKebab(BD_TL_RADIUS)}-input`;
export const BD_TR_RADIUS_INPUT_ID = `${PREFIX}-${camelToKebab(BD_TR_RADIUS)}-input`;
export const BD_BR_RADIUS_INPUT_ID = `${PREFIX}-${camelToKebab(BD_BR_RADIUS)}-input`;
export const BD_BL_RADIUS_INPUT_ID = `${PREFIX}-${camelToKebab(BD_BL_RADIUS)}-input`;
export const BD_RADIUS_EXPAND_ICON_ID = `${PREFIX}-${camelToKebab(BD_RADIUS)}-expand-icon`;

export const BD_WIDTH_INPUT_ID = `${PREFIX}-${camelToKebab(BD_WIDTH)}-input`;
export const BD_STYLE_INPUT_ID = `${PREFIX}-${camelToKebab(BD_STYLE)}-input`;
export const BD_COLOR_PICKER_ID = `${PREFIX}-${camelToKebab(BD_COLOR)}-color-picker`;
export const BD_COLOR_HEX_INPUT_ID = `${PREFIX}-${camelToKebab(BD_COLOR)}-hex-input`;
export const BD_COLOR_OPACITY_INPUT_ID = `${PREFIX}-${camelToKebab(BD_COLOR)}-opacity-input`;
export const BD_TOP_WIDTH_INPUT_ID = `${PREFIX}-${camelToKebab(BD_TOP_WIDTH)}-input`;
export const BD_TOP_STYLE_INPUT_ID = `${PREFIX}-${camelToKebab(BD_TOP_STYLE)}-input`;
export const BD_TOP_COLOR_PICKER_ID = `${PREFIX}-${camelToKebab(BD_TOP_COLOR)}-color-picker`;
export const BD_TOP_COLOR_HEX_INPUT_ID = `${PREFIX}-${camelToKebab(BD_TOP_COLOR)}-hex-input`;
export const BD_TOP_COLOR_OPACITY_INPUT_ID = `${PREFIX}-${camelToKebab(BD_TOP_COLOR)}-opacity-input`;
export const BD_RIGHT_WIDTH_INPUT_ID = `${PREFIX}-${camelToKebab(BD_RIGHT_WIDTH)}-input`;
export const BD_RIGHT_STYLE_INPUT_ID = `${PREFIX}-${camelToKebab(BD_RIGHT_STYLE)}-input`;
export const BD_RIGHT_COLOR_PICKER_ID = `${PREFIX}-${camelToKebab(BD_RIGHT_COLOR)}-color-picker`;
export const BD_RIGHT_COLOR_HEX_INPUT_ID = `${PREFIX}-${camelToKebab(BD_RIGHT_COLOR)}-hex-input`;
export const BD_RIGHT_COLOR_OPACITY_INPUT_ID = `${PREFIX}-${camelToKebab(BD_RIGHT_COLOR)}-opacity-input`;
export const BD_BOTTOM_WIDTH_INPUT_ID = `${PREFIX}-${camelToKebab(BD_BOTTOM_WIDTH)}-input`;
export const BD_BOTTOM_STYLE_INPUT_ID = `${PREFIX}-${camelToKebab(BD_BOTTOM_STYLE)}-input`;
export const BD_BOTTOM_COLOR_PICKER_ID = `${PREFIX}-${camelToKebab(BD_BOTTOM_COLOR)}-color-picker`;
export const BD_BOTTOM_COLOR_HEX_INPUT_ID = `${PREFIX}-${camelToKebab(BD_BOTTOM_COLOR)}-hex-input`;
export const BD_BOTTOM_COLOR_OPACITY_INPUT_ID = `${PREFIX}-${camelToKebab(BD_BOTTOM_COLOR)}-opacity-input`;
export const BD_LEFT_WIDTH_INPUT_ID = `${PREFIX}-${camelToKebab(BD_LEFT_WIDTH)}-input`;
export const BD_LEFT_STYLE_INPUT_ID = `${PREFIX}-${camelToKebab(BD_LEFT_STYLE)}-input`;
export const BD_LEFT_COLOR_PICKER_ID = `${PREFIX}-${camelToKebab(BD_LEFT_COLOR)}-color-picker`;
export const BD_LEFT_COLOR_HEX_INPUT_ID = `${PREFIX}-${camelToKebab(BD_LEFT_COLOR)}-hex-input`;
export const BD_LEFT_COLOR_OPACITY_INPUT_ID = `${PREFIX}-${camelToKebab(BD_LEFT_COLOR)}-opacity-input`;
export const BD_EXPAND_ICON_ID = `${PREFIX}-${camelToKebab(BORDER)}-expand-icon`;

export const BS_INSET_RADIO_GROUP_ID = `${PREFIX}-${camelToKebab(BOX_SHADOW)}-inset-radio-group`;
export const BS_OFFSET_X_INPUT_ID = `${PREFIX}-${camelToKebab(BOX_SHADOW)}-offset-x-input`;
export const BS_OFFSET_Y_INPUT_ID = `${PREFIX}-${camelToKebab(BOX_SHADOW)}-offset-y-input`;
export const BS_BLUR_RADIUS_INPUT_ID = `${PREFIX}-${camelToKebab(BOX_SHADOW)}-blur-radius-input`;
export const BS_SPREAD_RADIUS_INPUT_ID = `${PREFIX}-${camelToKebab(BOX_SHADOW)}-spread-radius-input`;
export const BS_COLOR_PICKER_ID = `${PREFIX}-${camelToKebab(BOX_SHADOW)}-color-picker`;
export const BS_COLOR_HEX_INPUT_ID = `${PREFIX}-${camelToKebab(BOX_SHADOW)}-hex-input`;
export const BS_COLOR_OPACITY_INPUT_ID = `${PREFIX}-${camelToKebab(BOX_SHADOW)}-opacity-input`;

export const GRID_TEMPLATE_COLUMNS_INPUT_ID = `${PREFIX}-${camelToKebab(GRID_TEMPLATE_COLUMNS)}-input`;
export const GRID_TEMPLATE_ROWS_INPUT_ID = `${PREFIX}-${camelToKebab(GRID_TEMPLATE_ROWS)}-input`;
export const COLUMN_GAP_INPUT_ID = `${PREFIX}-${camelToKebab(COLUMN_GAP)}-input`;
export const ROW_GAP_INPUT_ID = `${PREFIX}-${camelToKebab(ROW_GAP)}-input`;
export const GRID_COLUMN_INPUT_ID = `${PREFIX}-${camelToKebab(GRID_COLUMN)}-input`;
export const GRID_COLUMN_START_INPUT_ID = `${PREFIX}-${camelToKebab(GRID_COLUMN_START)}-input`;
export const GRID_COLUMN_END_INPUT_ID = `${PREFIX}-${camelToKebab(GRID_COLUMN_END)}-input`;
export const GRID_ROW_INPUT_ID = `${PREFIX}-${camelToKebab(GRID_ROW)}-input`;
export const GRID_ROW_START_INPUT_ID = `${PREFIX}-${camelToKebab(GRID_ROW_START)}-input`;
export const GRID_ROW_END_INPUT_ID = `${PREFIX}-${camelToKebab(GRID_ROW_END)}-input`;

export const FLEX_DIRECTION_SELECT_ID = `${PREFIX}-${camelToKebab(FLEX_DIRECTION)}-select`;
export const FLEX_WRAP_SELECT_ID = `${PREFIX}-${camelToKebab(FLEX_WRAP)}-select`;
export const JUSTIFY_CONTENT_SELECT_ID = `${PREFIX}-${camelToKebab(JUSTIFY_CONTENT)}-select`;
export const ALIGN_ITEMS_SELECT_ID = `${PREFIX}-${camelToKebab(ALIGN_ITEMS)}-select`;
export const ALIGN_CONTENT_SELECT_ID = `${PREFIX}-${camelToKebab(ALIGN_CONTENT)}-select`;
export const ORDER_INPUT_ID = `${PREFIX}-${camelToKebab(ORDER)}-input`;
export const FLEX_GROW_INPUT_ID = `${PREFIX}-${camelToKebab(FLEX_GROW)}-input`;
export const FLEX_SHRINK_INPUT_ID = `${PREFIX}-${camelToKebab(FLEX_SHRINK)}-input`;
export const FLEX_BASIS_INPUT_ID = `${PREFIX}-${camelToKebab(FLEX_BASIS)}-input`;
export const FLEX_RADIO_GROUP_ID = `${PREFIX}-${camelToKebab(FLEX)}-radio-group`;
export const FLEX_COLUMN_GAP_INPUT_ID = `${PREFIX}-${camelToKebab(COLUMN_GAP)}-${camelToKebab(FLEX)}-input`;
export const FLEX_ROW_GAP_INPUT_ID = `${PREFIX}-${camelToKebab(ROW_GAP)}-${camelToKebab(FLEX)}-input`;
export const ALIGN_SELF_SELECT_ID = `${PREFIX}-${camelToKebab(ALIGN_SELF)}-select`;

export const TRANSITION_PROPERTY_SELECT_ID = `${PREFIX}-${camelToKebab(TRANSITION_PROPERTY)}-select`;
export const TRANSITION_BEHAVIOR_SELECT_ID = `${PREFIX}-${camelToKebab(TRANSITION_BEHAVIOR)}-select`;
export const TRANSITION_DURATION_INPUT_ID = `${PREFIX}-${camelToKebab(TRANSITION_DURATION)}-input`;
export const TRANSITION_TIMING_FUNCTION_SELECT_ID = `${PREFIX}-${camelToKebab(TRANSITION_TIMING_FUNCTION)}-select`;
export const TRANSITION_DELAY_INPUT_ID = `${PREFIX}-${camelToKebab(TRANSITION_DELAY)}-input`;
export const ANIMATION_SELECT_ID = `${PREFIX}-${camelToKebab(ANIMATION)}-select`;

export const CURSOR_SELECT_ID = `${PREFIX}-${camelToKebab(CURSOR)}-select`;

// 溢出控制
export const OVERALL_OVERFLOW_SELECT_ID = `${PREFIX}-${camelToKebab(OVERFLOW)}-select`;
export const LEVEL_OVERFLOW_SELECT_ID = `${PREFIX}-${camelToKebab(OVERFLOW_X)}-select`;
export const VERTICAL_OVERFLOW_SELECT_ID = `${PREFIX}-${camelToKebab(OVERFLOW_Y)}-select`;

export const MASK_IMAGE_SELECT_ID = `${PREFIX}-${camelToKebab(MASK_IMAGE)}-select`;
export const MASK_CLIP_SELECT_ID = `${PREFIX}-${camelToKebab(MASK_CLIP)}-select`;
export const MASK_COMPOSITE_SELECT_ID = `${PREFIX}-${camelToKebab(MASK_COMPOSITE)}-select`;
export const MASK_MODE_SELECT_ID = `${PREFIX}-${camelToKebab(MASK_MODE)}-select`;
export const MASK_ORIGIN_SELECT_ID = `${PREFIX}-${camelToKebab(MASK_ORIGIN)}-select`;
export const MASK_POSITION_SELECT_ID = `${PREFIX}-${camelToKebab(MASK_POSITION)}-select`;
export const MASK_REPEAT_SELECT_ID = `${PREFIX}-${camelToKebab(MASK_REPEAT)}-select`;
export const MASK_SIZE_SELECT_ID = `${PREFIX}-${camelToKebab(MASK_SIZE)}-select`;
export const MASK_TYPE_SELECT_ID = `${PREFIX}-${camelToKebab(MASK_TYPE)}-select`;
export const BACKGROUND_SELECT_ID = `${PREFIX}-${camelToKebab(BACKGROUND)}-select`;
export const BACKGROUND_IMAGE_SELECT_ID = `${PREFIX}-${camelToKebab(BACKGROUND_IMAGE)}-select`;
export const BACKGROUND_REPEAT_SELECT_ID = `${PREFIX}-${camelToKebab(BACKGROUND_REPEAT)}-select`;
export const BG_COLOR_SELECT_ID = `${PREFIX}-${camelToKebab(BG_COLOR)}-select`;
export const BG_INSET_RADIO_GROUP_ID = `${PREFIX}-${camelToKebab(BG_COLOR)}-inset-radio-group`;
export const BACKGROUND_SIZE_SELECT_ID = `${PREFIX}-${camelToKebab(BACKGROUND_SIZE)}-select`;
export const BACKGROUND_SIZE_H_INPUT_ID = `${PREFIX}-${BACKGROUND_SIZE}-h-input`;
export const BACKGROUND_SIZE_W_INPUT_ID = `${PREFIX}-${BACKGROUND_SIZE}-w-input`;

export const TAILWIND_PREFIX = {
  [FONT_WEIGHT]: 'font',
  [COLUMN_GAP]: 'gap-y',
  [ROW_GAP]: 'gap-x',
  [FLEX_DIRECTION]: 'flex',
  [FLEX_WRAP]: 'flex',
  [JUSTIFY_CONTENT]: 'justify',
  [ALIGN_ITEMS]: 'items',
  [ALIGN_CONTENT]: 'content',
  [ORDER]: 'order',
  [FLEX]: 'flex',
  [FLEX_GROW]: 'grow',
  [FLEX_SHRINK]: 'shrink',
  [FLEX_BASIS]: 'basis',
  [ALIGN_SELF]: 'self',
  [TRANSITION_PROPERTY]: 'transition',
  [TRANSITION_BEHAVIOR]: 'transition',
  [TRANSITION_DURATION]: 'duration',
  [TRANSITION_TIMING_FUNCTION]: 'ease',
  [TRANSITION_DELAY]: 'delay',
  [ANIMATION]: 'animate',
  [CURSOR]: 'cursor',
  [OVERFLOW]: 'overflow',
  [OVERFLOW_X]: 'overflow-x',
  [OVERFLOW_Y]: 'overflow-y',
  [MASK_COMPOSITE]: 'mask',
  [MASK_CLIP]: 'mask-clip',
  [MASK_IMAGE]: 'mask',
  [MASK_MODE]: 'mask',
  [MASK_ORIGIN]: 'mask-origin',
  [MASK_POSITION]: 'mask',
  [MASK_REPEAT]: 'mask',
  [MASK_SIZE]: 'mask',
  [MASK_TYPE]: 'mask-type',
  [BG_COLOR]: 'bg',
  [BACKGROUND_IMAGE]: 'bg',
  [BACKGROUND_REPEAT]: 'bg',
  [BACKGROUND_SIZE]: 'bg-size',

};

/**
 * 响应式枚举
 */
export const SIMPLIFY = {
  "3xs":"16",
  "2xs":"18",
  "xs":"20",
  "sm":"24",
  "md":"28",
  "lg":"32",
  "xl":"36",
  "2xl":"42",
  "3xl":"48",
  "4xl":"56",
  "5xl":"64",
  "6xl":"72",
  "7xl":"80"
};
